export class FittingComboModel {

    //from clalculation algorithm
    public fittingName: string;
    public fittingType: string;

    //from planner
    public pipe0ID: string;
    public pipe0VertexID: string;
    public pipe0diameter: number;
    public pipe1ID: string;
    public pipe1VertexID: string;
    public pipe1diameter: number;

    //from db
    public productID: number;
    public productName: string;
}